export class TinValidationDto {
    tin: string
    idType?: string
    idValue?: string
    valid?: boolean
    validationMsg?: string
    envType?: MyEInvoiceLHDNEnv
}

export enum MyEInvoiceLHDNEnv {
    SANDBOX = 'SANDBOX',
    PRODUCTION = 'PRODUCTION'
  }